import { useEffect, useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { toast } from "sonner";

export const PORTALE_ATYPES = ["medici_legali", "avvocati", "mandanti", "cessionari", "periti"];

export const PortaleAccessoSection = ({ atype, itemId }) => {
  const [f, setF] = useState({ username: "", password: "" });
  const [show, setShow] = useState(false);
  const [busy, setBusy] = useState(false);
  const [sentAt, setSentAt] = useState(null);
  const base = `/anagrafiche/${atype}/${itemId}/portale`;

  useEffect(() => {
    if (!itemId) { return; }
    api.get(base).then(({ data }) => { setF((s) => ({ username: s.username || data.username, password: s.password || data.password })); setSentAt(data.credenziali_inviate_at); }).catch(() => {});
  }, [base, itemId]);

  const run = async (fn, ok) => {
    setBusy(true);
    try { await fn(); toast.success(ok); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(false); }
  };
  const salva = () => run(() => api.put(base, f), "Credenziali portale salvate");
  const invia = () => run(async () => { await api.put(base, f); await api.post(`${base}/invia`, { app_url: window.location.origin }); setSentAt(new Date().toISOString()); }, "Credenziali inviate via email");

  return (
    <div data-testid="section-portale-professionista">
      <div style={{ backgroundColor: "#7c3aed" }} className="px-4 py-2 rounded-t-lg text-white text-xs font-bold uppercase tracking-widest">ACCESSO PORTALE PROFESSIONISTI</div>
      <div className="border border-t-0 border-slate-800 rounded-b-lg p-4 bg-slate-900/20 space-y-3">
        {!itemId ? <p className="text-xs text-slate-500">Salva prima la scheda per impostare l'accesso al portale.</p> : (
          <>
            <div className="grid sm:grid-cols-2 gap-4">
              <div><Label className="text-slate-300">Username</Label>
                <Input value={f.username} onChange={(e) => setF((s) => ({ ...s, username: e.target.value.toLowerCase().replace(/\s/g, "") }))} data-testid="fld-portale-username" className="mt-1.5 bg-slate-900/60 border-slate-700 font-mono" /></div>
              <div><Label className="text-slate-300">Password (min. 8 caratteri)</Label>
                <div className="relative mt-1.5">
                  <Input type={show ? "text" : "password"} value={f.password} onChange={(e) => setF((s) => ({ ...s, password: e.target.value }))} data-testid="fld-portale-password" className="bg-slate-900/60 border-slate-700 font-mono pr-20" />
                  <button type="button" onClick={() => setShow((s) => !s)} data-testid="toggle-portale-password" className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-amber-400">{show ? "Nascondi" : "Mostra"}</button>
                </div></div>
            </div>
            <div className="flex items-center gap-3 flex-wrap">
              <button type="button" onClick={salva} disabled={busy} data-testid="portale-salva-btn" className="h-9 px-4 rounded-md border border-violet-500/50 text-violet-300 hover:bg-violet-500/10 text-sm font-semibold disabled:opacity-50">Salva accesso</button>
              <button type="button" onClick={invia} disabled={busy} data-testid="portale-invia-btn" className="h-9 px-4 rounded-md bg-violet-600 hover:bg-violet-700 text-white text-sm font-semibold disabled:opacity-50">{busy ? "Attendere…" : "Salva e invia credenziali"}</button>
              {sentAt && <span className="text-xs text-slate-500">Ultimo invio: {new Date(sentAt).toLocaleString("it-IT")}</span>}
            </div>
            <p className="text-[11px] text-slate-500">Le credenziali vengono inviate in automatico anche quando assegni il professionista a una pratica.</p>
          </>
        )}
      </div>
    </div>
  );
};
